export enum Role {
  SuperAdmin = 'SA',
  ToeBPflege = 'TP',
  ToeBFreigabe = 'TF',
  Kundenservice = 'KS',
  Diensleistung = 'DL',
  DSGVO = 'DG',
  InfrestAdmin = 'InfrestAdmin'
}
